import { fontStyleToCss } from '@/lib/fontStyle';
import type { DepartureLine as LineData } from '@/store/transforms';
import { DepartureTimes } from '@/widgets/DepartureWidget/DepartureTimes';
import {
  DEPARTURE_FONT_SIZE,
  LEGACY_BORDER_COLOR,
  type DepartureFonts,
} from '@/widgets/DepartureWidget/options';

/**
 * One line at a station: its boxed number, then one `DepartureTimes` column per direction.
 * Port of `departure/departureLine.vue`.
 *
 * Presentational only — see `DepartureTimes` for the shape of the legacy components this
 * replaces.
 */

export type DepartureLineProps = {
  line: LineData;
  fonts: DepartureFonts;
};

export function DepartureLine({ line, fonts }: DepartureLineProps) {
  const lineStyle = fontStyleToCss(fonts.line, { fontSize: DEPARTURE_FONT_SIZE });

  return (
    <div className="flex flex-col p-3">
      <span
        className="border-1 p-1 lineLabel"
        style={{ ...lineStyle, borderColor: LEGACY_BORDER_COLOR }}
      >
        {line.name}
      </span>
      <div className="flex justify-evenly gap-4">
        {line.headings.map((heading, index) => (
          <DepartureTimes key={index} heading={heading} fonts={fonts} />
        ))}
      </div>
    </div>
  );
}
